import { gql } from '@apollo/client';

export default gql`
  query providerTypes {
    providerTypes
  }
`;
